export default __webpack_public_path__ + "static/media/voc.57efdf63.mp3";